module.exports = __webpack_public_path__ + "static/img/verified.b1527c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/verified.png
// module id = bGrj
// module chunks = 7